<template>
 <div class="modal zoom" tabindex="-1" role="dialog" :id="idModal"> 
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" ><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title text-left">Status Aguardando Retorno Candidato</h4> 
      </div>
      <div class="modal-body">  
        <div class="form-group text-left">
            <label for="observacoes">Motivo: </label>
            <textarea class="form-control" rows="2" id="observacoes" v-model="observacoes" maxlength="100"></textarea>
            <small style="font-style:italic">Caracteres restantes: {{100 - observacoes.length}} </small>
        </div>   
      </div>
      <div class="modal-footer"> 
        <button type="button" class="btn btn-default" data-dismiss="modal" >Fechar</button>  
        <button type="button" class="btn btn-primary" @click="confirmar">
          <span v-show="!loadConfirmar">Confirmar</span>
          <i class="fa fa-circle-o-notch fa-spin" v-show="loadConfirmar"></i>   
        </button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
</template>
<script>
export default {
  methods: {
    confirmar: function () {
      let agendamentovm = {
        agendamento: this.agendados,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id,
        observacoes: this.observacoes
      }
      this.$http.post('aguardando-retorno', agendamentovm)
      .then(function (res) {
        location.reload()
      })
      .catch(function (err) {
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    }
  },
  props: ['idModal', 'agendados'],
  data () {
    return {
      dia: this.data,
      observacoes: '',
      loadConfirmar: false
    }
  }
}
</script>
<<style>

</style>



// WEBPACK FOOTER //
// AguardandoRetorno.vue?e97f972e